import React from 'react';
import { importantInfo } from '../../mock';
import { FileText, Plane, HeartPulse, ScrollText } from 'lucide-react';

const icons = [FileText, Plane, HeartPulse, ScrollText];

const ImportantInfo = () => {
  return (
    <section className="bg-warm py-24 md:py-32 border-y border-divider">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center reveal">
          <div className="gold-divider mb-4">
            <span className="chapter-badge text-gold uppercase">Important Information</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            A few gentle notes.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {importantInfo.map((it, i) => {
            const Icon = icons[i] || FileText;
            return (
              <div key={it.title} className="reveal bg-cream border border-divider px-7 py-7 flex gap-5">
                <div className="shrink-0 w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center">
                  <Icon size={18} className="text-gold" strokeWidth={1.4} />
                </div>
                <div>
                  <h3 className="font-serif-display text-navy text-xl">{it.title}</h3>
                  <p className="mt-2 font-sans-body text-navy/75 text-[0.95rem] leading-relaxed">{it.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImportantInfo;
